import { handleJsonResponse, requestGet, SERVICE_URL } from 'util/request';

export const getDiff = async () => {
  const response = await handleJsonResponse(await requestGet(`${SERVICE_URL}/release_dashboard/`));
  return response;
};
